import { Route, CanActivateFn, Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { inject } from '@angular/core';

export enum appRoutesType {
	CHAT = 'chat',
	TRAINING = 'training',
	TEST = 'test',
	HOME = 'home',
	PRACTICAL_CASES = 'practical-cases',
	FLASHCARDS = 'flashcards',
	TRUE_FALSE = 'true-false',
	CROSSCUTTING = 'crosscutting',
	LTI = 'lti',
	NOT_FOUND = 'not-found'
}

export const MAINTENANCE_MODE = false;

const homeRedirectGuard: CanActivateFn = (route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => {
	const router = inject(Router);
	const subjectId = route.queryParams['subjectId'];

	if (subjectId) {
		return router.createUrlTree([`/${subjectId}`]);
	} else {
		return router.createUrlTree([appRoutesType.NOT_FOUND]);
	}
};

let routes: Route[] = [
	{
		path: appRoutesType.CROSSCUTTING,
		loadComponent: () =>
			import('./pages/crosscutting/crosscutting.page.component').then((m) => m.CrosscuttingPageComponent)
	},
	{
		path: appRoutesType.HOME,
		canActivate: [homeRedirectGuard],
		loadComponent: () => import('./pages/not-found/not-found.page.component').then((m) => m.NotFoundPageComponent)
	},
	{
		path: appRoutesType.NOT_FOUND,
		loadComponent: () => import('./pages/not-found/not-found.page.component').then((m) => m.NotFoundPageComponent)
	},
	{
		path: `${appRoutesType.LTI}/:id`,
		loadComponent: () => import('./pages/lti/lti.page.component').then((m) => m.LtiPageComponent)
	},
	{
		path: `:subjectId`,
		children: [
			{
				path: '',
				loadComponent: () => import('./pages/chat/chat.page.component').then((m) => m.ChatPageComponent)
			},
			{
				path: `${appRoutesType.CHAT}/:chatId`,
				loadComponent: () => import('./pages/chat/chat.page.component').then((m) => m.ChatPageComponent)
			},
			{
				path: appRoutesType.FLASHCARDS,
				loadComponent: () =>
					import('./pages/flashcards/flashcards.page.component').then((m) => m.FlashcardsPageComponent)
			},
			{
				path: appRoutesType.TRUE_FALSE,
				loadComponent: () =>
					import('./pages/true-false/true-false.page.component').then((m) => m.TrueFalsePageComponent)
			},
			{
				path: `${appRoutesType.TEST}/:id`,
				loadComponent: () => import('./pages/test/test.page.component').then((m) => m.TestPageComponent)
			},
			{
				path: `${appRoutesType.PRACTICAL_CASES}/:id`,
				loadComponent: () =>
					import('./pages/practical-cases/practical-cases.page.component').then((m) => m.PracticalCasesPageComponent)
			},
			{
				path: `${appRoutesType.TRAINING}/:id`,
				loadComponent: () => import('./pages/training/training.page.component').then((m) => m.TrainingPageComponent)
			}
		]
	},
	{ path: '**', redirectTo: appRoutesType.NOT_FOUND }
];

if (MAINTENANCE_MODE) {
	const maintenanceComponentLoader = () =>
		import('./pages/maintenance/maintenance.page.component').then((m) => m.MaintenancePageComponent);

	const setMaintenance = (r: Route[]) => {
		r.forEach((route) => {
			if (
				route.path !== appRoutesType.CROSSCUTTING &&
				route.path !== appRoutesType.HOME &&
				route.path !== appRoutesType.NOT_FOUND &&
				route.path !== '**'
			) {
				if (route.children) {
					setMaintenance(route.children);
				}
				route.loadComponent = maintenanceComponentLoader;
				route.canActivate = [];
			}
		});
	};

	setMaintenance(routes);
}

export const appRoutes: Route[] = routes;
